<template>
	<app-content class="h-panel">
		<div class="h-panel-bar">
			<span class="h-panel-title">{{template.name}} - 数据项</span>
			<button @click="$router.back()" class="h-btn float-right">返回</button>
		</div>
		<div class="margin-top margin-left">
			<Button color="primary" @click="showForm()">添加项目</Button>
			<Button v-if="template.type == 1 && User.role !== 'View'" color="primary" :loading="syncLoading" @click="showSyncFormulaModal">同步公式到其他公司</Button>
		</div>
		<div class="h-panel-body">
			<Table :datas="templateItems" selectRow>
				<TableItem :width="80" align="center">
					<div slot-scope="{data}">{{data.isClassified?'归类':''}}</div>
				</TableItem>
				<TableItem title="名称">
					<div slot-scope="{data}" :class="{'font-bold':data.isBolder}" :style="{paddingLeft:((data.level-1)*15)+'px'}">{{data.title}}</div>
				</TableItem>
				<TableItem title="行次" align="center">
					<div slot-scope="{data}">{{data.isClassified?'':data.lineNum}}</div>
				</TableItem>
				<TableItem title="类型" v-if="template.type == 1">
					<div slot-scope="{data}">{{data.isClassified?'':data.type| dictMapping('reportTemplateItemType')}}</div>
				</TableItem>
				<TableItem title="取数来源">
					<div slot-scope="{data}">{{data.isClassified?'':data.sources| dictMapping('reportTemplateItemSources')}}</div>
				</TableItem>
				<TableItem title="显示位置" prop="pos" :width="80" align="center"></TableItem>
				<TableItem>
					<div class="actions" slot-scope="{data}">
						<span @click="showForm(data)">添加</span>
						<span @click="showForm({id:data.parentId},data)">编辑</span>
						<span v-if="!data.isClassified" @click="showFormulaModal(data,template.type)">公式</span>
						<span @click="remove(data)">删除</span>
					</div>
				</TableItem>
			</Table>
		</div>
		<TemplateItemModal @success="loadTemplate" :template="template" ref="templateItemModal" :templateItems="templateItems"/>
		<TemplateItemFormulaModal @success="loadTemplate" ref="templateItemFormulaModal" :templateItems="templateItems"/>

		<Modal v-model="syncFormulaModal" hasCloseIcon hasDivider :closeOnMask="false">
			<div slot="header">同步资产负债表公式到其他公司</div>
			<div v-width="760">
				<div class="sync-tip">
					仅同步同会计准则公司的资产负债表公式；系统会按科目编码和报表项目行次匹配，无法完整匹配的项目不会覆盖目标公司原公式。
				</div>
				<div v-if="!syncTargetList.length" class="red-color margin-top">暂无可同步的同准则公司。</div>
				<div v-else class="sync-target-list margin-top">
					<label v-for="item in syncTargetList" :key="item.id" class="sync-target-item">
						<input type="checkbox" :value="item.id" v-model="selectedTargetAccountSetsIds">
						<span>{{item.companyName}}</span>
					</label>
				</div>

				<Table v-if="syncResults.length" class="margin-top" :datas="syncResults" border>
					<TableItem title="公司" prop="companyName"/>
					<TableItem title="状态" :width="90">
						<template slot-scope="{data}">
							<span :class="syncStatusClass(data.status)">{{syncStatusText(data.status)}}</span>
						</template>
					</TableItem>
					<TableItem title="同步项目" prop="syncedItemCount" :width="80" align="center"/>
					<TableItem title="同步公式" prop="syncedFormulaCount" :width="80" align="center"/>
					<TableItem title="跳过项目" prop="skippedItemCount" :width="80" align="center"/>
					<TableItem title="提示">
						<template slot-scope="{data}">
							<ul v-if="data.messages && data.messages.length" class="sync-messages">
								<li v-for="(msg,index) in data.messages" :key="index">{{msg}}</li>
							</ul>
							<span v-else>-</span>
						</template>
					</TableItem>
				</Table>
			</div>
			<div slot="footer">
				<Button @click="syncFormulaModal=false" :loading="syncLoading">关闭</Button>
				<Button color="primary" :loading="syncLoading" :disabled="!selectedTargetAccountSetsIds.length" @click="syncFormula">开始同步</Button>
			</div>
		</Modal>
	</app-content>
</template>

<script>

	import {mapState} from 'vuex'
	import TemplateItemModal from "./TemplateItemModal";
	import TemplateItemFormulaModal from "./TemplateItemFormulaModal";

	export default {
		name: "TemplateForm",
		components: {TemplateItemFormulaModal, TemplateItemModal},
		inject: ['reload'],
		props: {
			templateId: [Number, String]
		},
		data() {
			return {
				template: {},
				templateItemFormulaModel: false,
				templateItem: null,
				templateItemFormula: null,
				templateItemFormulas: [],
				syncFormulaModal: false,
				syncLoading: false,
				selectedTargetAccountSetsIds: [],
				syncResults: []
			}
		},
		computed: {
			...mapState(['User', 'currentAccountSets', 'myAccountSets']),
			templateItems() {
				return this.template.items || [];
			},
			syncTargetList() {
				if (!this.currentAccountSets || !this.myAccountSets) {
					return [];
				}
				return this.myAccountSets.filter(item => {
					return item.id !== this.currentAccountSets.id && item.accountingStandards == this.currentAccountSets.accountingStandards;
				});
			}
		},
		methods: {
			showForm(parent, org) {
				this.$refs.templateItemModal.toggle(parent, org);
			},
			showFormulaModal(item, type) {
				this.$refs.templateItemFormulaModal.toggle(item, type);
			},
			showSyncFormulaModal() {
				this.selectedTargetAccountSetsIds = [];
				this.syncResults = [];
				this.syncFormulaModal = true;
			},
			syncFormula() {
				if (!this.selectedTargetAccountSetsIds.length) {
					this.$Message("请选择要同步的公司");
					return;
				}
				this.$Confirm("确认将当前资产负债表公式同步到选中的公司？能完整映射的项目公式会覆盖目标公司原公式，无法映射的项目不会覆盖。", "同步公式").then(() => {
					this.syncLoading = true;
					Api.report.template.syncFormula(this.templateId, {targetAccountSetsIds: this.selectedTargetAccountSetsIds}).then(({data}) => {
						this.syncResults = data || [];
						this.$Message("同步完成");
					}).finally(() => {
						this.syncLoading = false;
					});
				});
			},
			syncStatusText(status) {
				switch (status) {
					case 'SUCCESS':
						return '成功';
					case 'SKIPPED':
						return '部分跳过';
					case 'FAILED':
						return '失败';
					default:
						return status || '-';
				}
			},
			syncStatusClass(status) {
				return {
					SUCCESS: 'green-color',
					SKIPPED: 'text-orange',
					FAILED: 'red-color'
				}[status] || '';
			},
			loadTemplate() {
				Api.report.template.load(this.templateId).then(({data}) => {
					this.template = data;
				});
			},
			remove(data) {
				this.$Confirm("确认删除?").then(() => {
					Api.report.template.items.delete(data.id).then(() => {
						this.loadTemplate();
					})
				})
			}
		},
		mounted() {
			this.loadTemplate()
		}
	}
</script>

<style scoped>
	.sync-tip {
		line-height: 22px;
		color: #666;
	}

	.sync-target-list {
		max-height: 220px;
		overflow: auto;
		border: 1px solid #eee;
		padding: 8px 12px;
	}

	.sync-target-item {
		display: block;
		line-height: 28px;
		cursor: pointer;
	}

	.sync-target-item input {
		margin-right: 8px;
	}

	.sync-messages {
		margin: 0;
		padding-left: 16px;
	}

	.text-orange {
		color: #f90;
	}
</style>
